import React from 'react';

import { NotificationProvider } from './src/context/AddItemNotificationProvider';
import { GlobalProvider } from './src/context/GlobalContext';

export const wrapRootElement = ({ element }) => (
  <GlobalProvider><NotificationProvider>{element}</NotificationProvider></GlobalProvider>
);
